import { apiSlice } from '../../../app/api/apiSlice';
import Config from '../../../configs/appConfig';
import makeQueryParams from '../../../lib/makeQueryParams';



export const LocalNotificationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    return ({
      getLocalNotifications: builder.query({
        query: (params) => {
          const queryParams = makeQueryParams(params.queryParams);

          return ({ url: `/${Config.VITE_HC_API_VERSION}/local-notifications${queryParams}${params?.includes || ''}` });
        },
        transformResponse: (response) => {
          return {
            data: response?.data,
            pagination: response?.meta?.pagination,
          };
        },
        transformErrorResponse: (response) => response?.data?.errors,
        providesTags: [ 'LocalNotifications' ],
        keepUnusedDataFor: 1,
      }),
      getSpecificLocalNotification: builder.query({
        query: ({ notificationId, includes }) => ({ url: `/${Config.VITE_HC_API_VERSION}/local-notifications/${notificationId}${includes}` }),
        transformResponse: (response) => response.data,
        providesTags: [ 'LocalNotificationItem' ],
      }),
      createLocalNotification: builder.mutation({
        query: (values) => ({
          url: `/${Config.VITE_HC_API_VERSION}/local-notifications`,
          method: 'POST',
          body: values,
        }),
        invalidatesTags: () => [ 'LocalNotifications', 'Template' ],
      }),
      updateLocalNotification: builder.mutation({
        query: ({ id, values }) => ({
          url: `/${Config.VITE_HC_API_VERSION}/local-notifications/${id}`,
          method: 'POST',
          body: values,
        }),
        invalidatesTags: () => [ 'LocalNotifications', 'Template', 'LocalNotificationItem' ],
      }),
      deleteLocalNotification: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/local-notifications/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [ 'LocalNotifications', 'Template' ],
      }),
      unpublishLocalNotification: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/local-notifications/${id}/unpublish`,
          method: 'POST',
        }),
        invalidatesTags: () => [ 'LocalNotifications', 'LocalNotificationItem' ],
      }),
    });
  },
});

export const {
  useGetLocalNotificationsQuery,
  useGetSpecificLocalNotificationQuery,
  useCreateLocalNotificationMutation,
  useUpdateLocalNotificationMutation,
  useDeleteLocalNotificationMutation,
  useUnpublishLocalNotificationMutation,
} = LocalNotificationsApiSlice;
